import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { History } from "lucide-react";

export function ImpegniHistoryPicker({ students, values, onChange }) {
  const [onlyNever, setOnlyNever] = useState(true);
  const { data: hist = {} } = useQuery({
    queryKey: ["impegni-history"],
    queryFn: async () => (await api.get("/mansioni-area/impegni/history")).data,
  });
  const list = useMemo(() => students
    .filter((s) => (s.status || "attivo") === "attivo")
    .map((s) => ({ ...s, h: hist[s.id] }))
    .filter((s) => !onlyNever || !s.h)
    .sort((a, b) => (a.h?.count || 0) - (b.h?.count || 0) || (a.h?.last_date || "").localeCompare(b.h?.last_date || "") || `${a.last_name}`.localeCompare(`${b.last_name}`)),
  [students, hist, onlyNever]);
  const sel = new Set(values);
  const toggle = (id) => onChange(sel.has(id) ? values.filter((v) => v !== id) : [...values, id]);

  return (
    <div className="mt-2 border border-stone-200 rounded-md" data-testid="imp-history-picker">
      <div className="flex items-center justify-between px-3 py-2 border-b border-stone-100 bg-stone-50">
        <span className="text-xs text-stone-600 inline-flex items-center gap-1.5"><History size={12}/> Storico impegni esterni</span>
        <div className="flex gap-1">
          {[[true, "Mai fatto"], [false, "Tutti (dal meno impegnato)"]].map(([v, l]) => (
            <button key={l} type="button" onClick={() => setOnlyNever(v)} data-testid={`imp-history-${v ? "never" : "all"}`}
              className={`px-2 py-0.5 rounded-full text-[11px] border transition-colors ${onlyNever === v ? "bg-[#1C352D] text-white border-[#1C352D]" : "bg-white border-stone-200 text-stone-600"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="max-h-48 overflow-y-auto divide-y divide-stone-100">
        {list.length === 0 && <div className="px-3 py-3 text-xs text-stone-400">Tutti gli studenti attivi hanno già fatto almeno un impegno.</div>}
        {list.map((s) => (
          <label key={s.id} className="flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer hover:bg-stone-50" data-testid={`imp-history-row-${s.id}`}>
            <input type="checkbox" checked={sel.has(s.id)} onChange={() => toggle(s.id)}/>
            <span className="flex-1">{s.last_name} {s.first_name}</span>
            {s.h ? (
              <span className="text-[11px] text-stone-500" title={s.h.last_title || ""}>{s.h.count} {s.h.count === 1 ? "impegno" : "impegni"} · ultimo {fmtDate(s.h.last_date)}</span>
            ) : (
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200">Mai fatto</span>
            )}
          </label>
        ))}
      </div>
    </div>
  );
}
